import FleetHelper from 'features/Fleet/fleetHelper';
import { AnimatePresence, motion } from 'framer-motion';
import AppTabs from 'general/components/AppTabs';
import KTLabel, { KTLabelSize } from 'general/components/OtherKeenComponents/KTLabel';
import CustomCard from 'general/components/Others/CustomCard';
import VITableRowDropDown from 'general/components/VITableRowDropDown';
import AppColors from 'general/constants/AppColors';
import AppConstants from 'general/constants/AppConstants';
import AppResource from 'general/constants/AppResource';
import Utils from 'general/utils/Utils';
import useRouter from 'hooks/useRouter';
import useScrollToTop from 'hooks/useScrollToTop';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import ChargeHelper from 'features/Charge/chargeHelper';
import BankAccountsView from 'features/ManageDealer/components/BankAccountsView';
import UIHelper from 'general/helpers/UIHelper';
import FleetUIHelper from 'features/Fleet/fleetUIHelper';
import FleetContractListView from 'features/Fleet/FleetContract/components/FleetContractListView';
import ChargeDriverListView from 'features/Charge/ChargeDriver/components/ChargeDriverListView';
import FleetTransactionView from '../FleetTransactionView';

FleetDetailView.propTypes = {};

function FleetDetailView(props) {
    // ---- params ----
    const { agencyId, isFleetInfo = false } = props;
    const { t } = useTranslation();
    const router = useRouter();
    const fleetInfoRef = useRef();
    const { user, permissionList } = useSelector((state) => state.auth);
    const adminRole = user?.role === 'ADMIN' || user?.role === 'OPERATOR';
    const [fleetDetail, setFleetDetail] = useState();
    const isFleetIndividual = useMemo(() => {
        return fleetDetail && fleetDetail?.type === AppConstants.accountType.individual;
    }, [fleetDetail]);
    const isAdminFleet = useMemo(() => {
        if (fleetDetail) {
            return !fleetDetail?.parentFleetId
        }
        return false;
    }, [fleetDetail])
    const fleetBank = useMemo(() => {
        return fleetDetail?.bankAccounts?.length ? fleetDetail?.bankAccounts[0] : {}
    }, [fleetDetail]);

    const [fleetBankList, setFleetBankList] = useState([]);

    const areaTree = useSelector((state) => state.app.areaTree);
    const [fleetArea, setFleetArea] = useState(null);
    const [fleetParentArea, setFleetParentArea] = useState(null);
    useEffect(() => {
        if (areaTree && !_.isEmpty(areaTree) && fleetDetail) {
            const fleetAreaId = fleetDetail?.areaId;
            const fleetArea = ChargeHelper.Utils.getAreaById([areaTree], fleetAreaId);
            if (fleetArea?.typeCode === 'W') {
                setFleetArea(fleetArea);
                setFleetParentArea(ChargeHelper.Utils.getAreaById([areaTree], fleetArea?.parentId));
            } else if (fleetArea?.typeCode === 'P') {
                setFleetParentArea(fleetArea);
            }
        }
    }, [areaTree, fleetDetail]);
    const [fleetWorkArea, setFleetWorkArea] = useState(null);
    const [fleetParentWorkArea, setFleetParentWorkArea] = useState(null);
    useEffect(() => {
        if (areaTree && !_.isEmpty(areaTree) && fleetDetail) {
            const fleetWorkAreaId = fleetDetail?.workAddress?.workAreaId;
            const fleetWorkArea = ChargeHelper.Utils.getAreaById([areaTree], fleetWorkAreaId);
            if (fleetWorkArea?.typeCode === 'W') {
                setFleetWorkArea(fleetWorkArea);
                setFleetParentWorkArea(ChargeHelper.Utils.getAreaById([areaTree], fleetWorkArea?.parentId));
            } else if (fleetWorkArea?.typeCode === 'P') {
                setFleetParentWorkArea(fleetWorkArea);
            }
        }
    }, [areaTree, fleetDetail]);

    useEffect(() => {
        if (adminRole || isFleetInfo) {
            handleGetFleetBankList();
        }
    }, [agencyId, adminRole, isFleetInfo]);

    const handleGetFleetBankList = async () => {
        const res = await FleetHelper.API.requestGetFleetBankList({ agencyId: agencyId });
        setFleetBankList(res);
    };

    const hash = router?.location?.hash;
    const [selectedTab, setSelectedTab] = useState('Danh sách hợp đồng');
    const tabs = useMemo(() => {
        if (isFleetInfo) {
            return ['Danh sách hợp đồng', 'Tài khoản ngân hàng'].reverse();
        } else {
            return ['Danh sách hợp đồng', 'Danh sách tài xế', 'Lịch sử giao dịch', 'Tài khoản ngân hàng'].reverse();
        }
    }, [t, isFleetInfo]);

    useEffect(() => {
        if (hash === '#contract-list') setSelectedTab('Danh sách hợp đồng');
        if (hash === '#driver-list') setSelectedTab('Danh sách tài xế');
        if (hash === '#transaction-history') setSelectedTab('Lịch sử giao dịch');
        if (hash === '#bank-accounts') setSelectedTab('Tài khoản ngân hàng');
    }, [hash]);
    const getFleetDetail = (id) => {
        if (!id) return;
        FleetHelper.API.requestGetFleetDetail(id).then((data) => {
            if (data && Object.keys(data)?.length > 0) {
                setFleetDetail(data);
            } else {
                router.navigate(-1);
            }
        });
    };

    useEffect(() => {
        getFleetDetail(agencyId);
    }, [agencyId]);


    const contractListView = useMemo(() => {
        return <FleetContractListView agencyId={agencyId} fleetDetail={fleetDetail} onRefresh={() => getFleetDetail(agencyId)} />;
    }, [agencyId, fleetDetail]);

    const fleetDriverListView = useMemo(() => {
        return <ChargeDriverListView agencyId={agencyId} isFleetDriver={true} onRefresh={() => getFleetDetail(agencyId)} />;
    }, [agencyId]);

    const fleetTransactionListView = useMemo(() => {
        return <FleetTransactionView agencyId={agencyId} showFullUI={false} agencyDetail={fleetDetail} />;
    }, [agencyId]);

    const bankAccountsView = useMemo(() => {
        return (
            <BankAccountsView
                agencyId={agencyId}
                agencyDetail={fleetDetail}
                banksList={fleetBankList}
                getAgencyBankList={handleGetFleetBankList}
            />
        );
    }, [agencyId, fleetDetail, fleetBankList]);

    // ---- methods ----

    const handleShowEditAgency = (row) => {
        router.navigate(`edit`);
    };

    useScrollToTop();

    const handleSelectedTab = (newTab) => {
        if (selectedTab === newTab) return;
        if (newTab === 'Danh sách hợp đồng') {
            router.navigate('#contract-list');
        }
        if (newTab === 'Danh sách tài xế') {
            router.navigate('#driver-list');
        }
        if (newTab === 'Lịch sử giao dịch') {
            router.navigate('#transaction-history');
        }
        if (newTab === 'Tài khoản ngân hàng') {
            router.navigate('#bank-accounts');
        }
        setSelectedTab(newTab);
    };

    const FleetInfo = () => {
        return (
            <div
                className="row m-0 position-relative p-3 bg-white rounded-lg"
                style={{
                    border: `1px solid ${AppColors.gray[300]}`,
                    boxShadow: '0px 7px 8px -3px #0000000D',
                }}
            >
                <div className="d-flex px-0 align-items-start w-100">
                    <div className="d-flex align-items-center w-95">
                        <img
                            className="rounded-circle"
                            src={
                                (() => {
                                    const ownerUser = fleetDetail?.users?.find(
                                        user => user?.email === fleetDetail?.email
                                    );
                                    return ownerUser?.avatar
                                        ? Utils.getFullUrl(ownerUser.avatar)
                                        : AppResource.icons.avatar.default;
                                })()
                            }
                            style={{
                                width: 44,
                            }}
                        />
                        <div className="d-flex flex-column ml-3 w-100">
                            <div className="d-flex align-items-start gap-2" style={{ overflow: 'hidden' }}>
                                <span
                                    // className="font-weight-bolder text-ellipsis-2-lines"
                                    style={UIHelper.buildFontStyle('600', '18px', AppColors.gray[800])}
                                >
                                    {fleetDetail?.name}
                                </span>

                                <span className="min-w-100px pt-1">
                                    <KTLabel
                                        text={t(`agencyStatus_${fleetDetail?.status}`)}
                                        isInline={true}
                                        size={KTLabelSize.medium}
                                        additionalClassName={`label-light-${FleetHelper.Utils.getFleetStatusColor(
                                            fleetDetail?.status
                                        )}`}
                                    />
                                </span>
                            </div>
                            <div className="d-flex align-items-center gap-2">
                                <div
                                    style={{
                                        color: AppColors.gray[700],
                                        fontSize: Utils.returnFontSize(14),
                                        fontWeight: 400,
                                    }}
                                >
                                    Số dư ví:
                                </div>
                                <span
                                    style={{
                                        color: AppColors.gray[800],
                                        fontSize: Utils.returnFontSize(13),
                                        fontWeight: 600,
                                    }}
                                >
                                    {Utils.formatNumber(fleetDetail?.users?.[0]?.wallets?.[0]?.balance ?? 0)} VNĐ
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className="d-flex gap-3 justify-content-end ml-auto">
                        <VITableRowDropDown
                            toggleElement={
                                <a
                                    href="#"
                                    className="btn btn-sm btn-clean btn-icon h-45px w-45px hover-opacity-60"
                                    style={{ backgroundColor: AppColors.gray[200] }}
                                    onClick={(e) => {
                                        e.preventDefault();
                                    }}
                                >
                                    <i
                                        className="fa-solid fa-ellipsis"
                                        style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                    />
                                </a>
                            }
                            menuItem={[
                                {
                                    iconElement: (
                                        <i
                                            className="fa-regular fa-bolt"
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: 'Kích hoạt tài khoản',
                                    click: () => {
                                        FleetHelper.UI.showDialogConfirmAcceptFleet(fleetDetail, () => {
                                            getFleetDetail(agencyId);
                                        });
                                    },
                                    show: fleetDetail?.status === 'REGISTERED',
                                },
                                {
                                    iconElement: (
                                        <i
                                            className="fa-regular fa-pen-to-square"
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: 'Chỉnh sửa',
                                    click: () => {
                                        handleShowEditAgency(fleetDetail);
                                    },
                                    show: (!fleetDetail?.numberOfSignedContracts || adminRole || isFleetInfo),
                                },
                                {
                                    iconElement: (
                                        <i
                                            className="fa-regular fa-square-dollar"
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: 'Nạp tiền cho doanh nghiệp',
                                    click: () => {
                                        FleetHelper.UI.showDialogTopUpFleet(fleetDetail, () => {
                                            getFleetDetail(agencyId);
                                        });
                                    },
                                    show: adminRole,
                                },
                                {
                                    iconElement: (
                                        <i
                                            className="far fa-square"
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: 'Ngừng hoạt động',
                                    click: () => {
                                        FleetHelper.UI.showDialogConfirmStopFleet(fleetDetail, () => {
                                            getFleetDetail(agencyId);
                                        });
                                    },
                                    show: adminRole && fleetDetail?.status === 'NORMAL',
                                },
                                {
                                    iconElement: (
                                        <i
                                            className="far fa-play"
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: 'Khôi phục hoạt động',
                                    click: () => {
                                        FleetHelper.UI.showDialogConfirmActiveFleet(fleetDetail, () => {
                                            getFleetDetail(agencyId);
                                        });
                                    },
                                    show: adminRole && fleetDetail?.status === 'SUSPENDED',
                                },
                                {
                                    iconElement: (
                                        <i
                                            className="fa-regular fa-file-contract"
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: 'Tạo hợp đồng DNVT',
                                    click: () => {
                                        FleetHelper.UI.showDialogConfirmCreateContractWithFleet(fleetDetail, () => { });
                                    },
                                    show: adminRole &&
                                        fleetDetail?.status !== 'REGISTERED'
                                },
                                {
                                    iconElement: (
                                        <i
                                            className={`fa-regular fa-lock`}
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: 'Đặt lại mật khẩu',
                                    click: () => {
                                        FleetHelper.UI.showDialogConfirmChangeFleetPassword(fleetDetail, () => {
                                            getFleetDetail(agencyId);
                                        });
                                    },
                                    show: adminRole,
                                },
                                {
                                    iconElement: (
                                        <i
                                            className={`fa-regular fa-trash-can`}
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: 'Xóa đối tác',
                                    click: () => {
                                        FleetHelper.UI.showDialogConfirmDeleteFleet(fleetDetail, () => {
                                            getFleetDetail(agencyId);
                                        });
                                    },
                                    show: adminRole,
                                },
                            ]}
                            singleBtnBgColor={AppColors.gray[200]}
                        />
                    </div>
                </div>

                <div
                    className="my-4"
                    style={{
                        borderTop: `1px dashed ${AppColors.gray[300]}`,
                    }}
                />

                {/* thong tin DNVT */}
                <div className="col-xl-12 col-lg-12 col-md-12 d-flex flex-column px-0 ">
                    <div className=" d-flex flex-lg-row flex-column flex-wrap">
                        <>
                            <div className="col-xl-6 p-0 pr-xl-3 pl-0 pr-0 my-1 d-flex flex-column gap-3">
                                {FleetUIHelper.buildAccountInfoCard(fleetDetail, isFleetIndividual, adminRole)}
                                {FleetUIHelper.buildDocumentInfoCard(fleetDetail, isFleetIndividual)}

                                {!isFleetIndividual && FleetUIHelper.buildHsmAgreementCard(fleetDetail)}

                                {isFleetIndividual && FleetUIHelper.buildEKYCInfoCard(fleetDetail, () => getFleetDetail(agencyId))}

                                {isFleetIndividual && FleetUIHelper.buildHsmAgreementCard(fleetDetail)}
                            </div>

                            <div className="col-xl-6 p-0 my-1 d-flex flex-column gap-3">
                                {FleetUIHelper.buildOtherInfoCard(fleetDetail, fleetParentArea, fleetArea, fleetBank, isFleetIndividual, adminRole, isFleetInfo)}

                                {FleetUIHelper.buildChargePaymentCard(fleetDetail)}
                            </div>
                        </>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div>
            <div className={``}>
                {/* thong tin DNVT */}
                <CustomCard
                    showHeader={false}
                    additionalClassName="rounded-lg overflow-hidden mx-4"
                    bgTransparent={true}
                    showBorder={false}
                    body={
                        <div className="d-xl-flex d-lg-flex">
                            <div
                                className="col-12 p-0 h-100"
                                ref={fleetInfoRef}
                            >
                                {/* thong tin DNVT */}
                                <FleetInfo />
                            </div>
                        </div>
                    }
                />

                {/* table */}
                <div className=''>
                    {tabs?.length > 1 && (
                        <div className="px-4">
                            <AppTabs tabs={tabs} activeTab={selectedTab} handleClick={handleSelectedTab} />
                        </div>
                    )}
                    <AnimatePresence mode="wait">
                        <motion.div
                            key={selectedTab}
                            initial={{ y: 10, opacity: 0 }}
                            animate={{ y: 0, opacity: 1 }}
                            exit={{ y: -10, opacity: 0 }}
                            transition={{ duration: 0.2 }}
                        >
                            {selectedTab == 'Danh sách hợp đồng' && <div>{contractListView}</div>}
                            {selectedTab == 'Danh sách tài xế' && <div className='mx-4'>{fleetDriverListView}</div>}
                            {selectedTab == 'Lịch sử giao dịch' && <div className='mx-4'>{fleetTransactionListView}</div>}
                            {selectedTab == 'Tài khoản ngân hàng' && <div className='mx-4'>{bankAccountsView}</div>}
                        </motion.div>
                    </AnimatePresence>
                </div>
            </div>
        </div>
    );
}

export default FleetDetailView;
